import { useEffect } from "react";

import { postTrackingData } from "@/api/endpoints/track";
import { useIntercom } from "@/hooks/useIntercom";
import { useOrganization } from "@/hooks/useOrganization";
import { EVENT } from "@/tracking_events";
import Typography from "@components/Typography";

import styles from "./MaxAlertLimitReached.module.css";

export const MaxAlertLimitReached = () => {
  const { data: orgData } = useOrganization();
  const { has_reached_num_alert_limit = false, plan = null } = orgData?.ok
    ? orgData.data
    : {};

  const max_num_alerts = plan?.max_num_alerts;
  const { show } = useIntercom();

  useEffect(() => {
    has_reached_num_alert_limit &&
      postTrackingData(EVENT.ALERT_LIMIT_REACHED_VIEWED);
  }, [has_reached_num_alert_limit]);

  if (!has_reached_num_alert_limit) return null;

  return (
    <div className={styles.root} data-testid="limit-reached-text">
      <div className={styles.content}>
        <Typography variant="h3">
          {L.CREATE_NEW_ALERT_DISABLED_INFO_TEXT_BEGINNING} {max_num_alerts}{" "}
          {max_num_alerts && max_num_alerts > 1
            ? L.NAV_CREATE_NEW_ALERT_DISABLED_ALERT_PLURAL
            : L.NAV_CREATE_NEW_ALERT_DISABLED_ALERT_SINGULAR}{" "}
        </Typography>
        <Typography variant="subtitle-1">
          {L.CREATE_NEW_ALERT_DISABLED_INFO_TEXT_MIDDLE}{" "}
          <a
            onClick={(e) => {
              e.preventDefault();
              show?.();
            }}
          >
            {L.CREATE_NEW_ALERT_DISABLED_INFO_TEXT_CHAT}
          </a>{" "}
          {L.CREATE_NEW_ALERT_DISABLED_INFO_TEXT_END}
        </Typography>
      </div>
    </div>
  );
};
